import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { saCard, fmtD, SABadge, ACCOUNT_STATUS } from "../../components/saShared";

export default function SAAbbonamenti() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/superadmin/subscriptions").then((r) => setList(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-4" data-testid="sa-abbonamenti">
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">Abbonamenti</h1>
      <div className={`${saCard} overflow-x-auto`}>
        <table className="w-full text-sm min-w-[760px]">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-wider text-zinc-500 border-b border-zinc-800">
              {["Ristorante", "Piano", "Subscription", "Account", "Prossimo rinnovo", "Stripe Customer", "Stripe Subscription", ""].map((h) => (
                <th key={h} className="px-4 py-3 font-semibold">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800/60">
            {list.map((s) => (
              <tr key={s.id} className="hover:bg-zinc-800/40" data-testid={`sa-sub-${s.id}`}>
                <td className="px-4 py-3 font-semibold text-zinc-100">{s.name}</td>
                <td className="px-4 py-3 text-zinc-300">{s.plan_name}</td>
                <td className="px-4 py-3 text-xs text-zinc-400 capitalize">{(s.subscription_status || "—").replaceAll("_", " ")}</td>
                <td className="px-4 py-3"><SABadge map={ACCOUNT_STATUS} value={s.account_status} /></td>
                <td className="px-4 py-3 text-xs text-zinc-300">{fmtD(s.next_payment_at)}</td>
                <td className="px-4 py-3 text-xs font-mono text-zinc-500">{s.stripe?.customer_id || "—"}</td>
                <td className="px-4 py-3 text-xs font-mono text-zinc-500">{s.stripe?.subscription_id || "—"}</td>
                <td className="px-4 py-3">
                  <Link to={`/superadmin/ristoranti/${s.id}`} data-testid={`sa-sub-open-${s.id}`}
                    className="h-8 px-3 inline-flex items-center rounded-md bg-zinc-800 text-zinc-200 text-xs font-semibold">Apri</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
